export const formatCrremMissingField = (key: string) => {
  const withUnit = key.replace(/M2$/, " m²");
  const spaced = withUnit.replace(/([a-z])([A-Z])/g, "$1 $2");
  if (spaced.length === 0) return key;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const formatCrremMissingFields = (keys: string[]) => keys.map(formatCrremMissingField).join(", ");
